/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from "graphql-tag";

export const GET_DISCOUNT_REPORT = gql`
  query Content($filters: CouponReportFilterInput) {
    getCouponsReport(filters: $filters) {
      content {
        name
        _id
        presentation {
          name
        }
        couponCode
        couponType
        value
        sectionName
        sectionOptType {
          name
        }
        section {
          name
        }
        endDate

        startDate
        Boxes {
          amountPaid
          totalAmount
          id
        }
        status
        usedCount
        User {
          email
          firstName
          lastName
        }
      }
    }
  }
`;
